var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onimg",staticStyle:{"padding-top":"150px"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":"logo.png"}}),_c('br')])
}]

export { render, staticRenderFns }